import styles from "./SuccessTick.module.css";

export default function SuccessTick({ size = 24, color = "#10b981" }) {
  return (
    <div className={styles.successTick} style={{ width: size, height: size }}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: "100%", height: "100%" }}
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke={color}
          strokeWidth="2"
          fill="none"
          className={styles.circle}
        />
        <path
          d="M9 12L11 14L15 10"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={styles.checkmark}
        />
      </svg>
    </div>
  );
}
